import React, { useState, useEffect } from 'react'
import moment from 'moment'
import store from 'store'
import { Select, DatePicker, Icon } from 'antd'
import { _convertObject } from "../../../helpers/convertObject"
import ImprovedQuantityStatisticsTable from './table/ImprovedQuantityStatisticsTable'
import { statisticImproved, exportStatisticQCHT } from "../../../services/api/3dApi"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import ReactHTMLTableToExcel from "react-html-table-to-excel";

function ImprovedQuantityStatisticsPage() {
    const storeName = 'GarmentQuantityStatisticsFilter'
    const checkStoreValue = (field, value) => {
        return store.get(storeName) !== undefined ? store.get(storeName)[field] : value
    }
    const [list, setList] = useState([])
    const [totalWithTimeSlot, setTotalWithTimeSlot] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({
        statistic_date: moment().format('YYYY-MM-DD'),
        sort: 'time_slot'
    })

    const { Option } = Select

    const fetchList = async () => {
        setLoading(true)


        try {
            let payload = {
                ...filters,
            }
            const { data: response } = await statisticImproved(payload)
            const { data: res, success, error } = response

            if (!success) {
                setError(error)
                setLoading(false)
                return
            }

            const { data, total, totalWithTimeSlot} = { ...res }
            setList(data)
            setTotalWithTimeSlot(totalWithTimeSlot)
            setTotal(total)
            setLoading(false)
            setError('')
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
      const intervalId = setInterval(() => {
        callApiOnExactHour();
      }, 1000);
  
      return () => {
        clearInterval(intervalId); 
      };
    }, []);

    useEffect(()=> {
        fetchList()
    },[filters])

    const callApiOnExactHour = () => {
        const currentHour = moment().format("HH:mm:ss")
        if (currentHour.includes(':00:00')) {
            fetchList()
        }
    }

    const handleUpdateStorage = (params) => {
        const storage = store.get('QCHTStatisticsFilter')

        store.set('QCHTStatisticsFilter', {
            ...storage,
            ...params
        })
    }

    const handleChangeDate = (dateString) => {
        const currentTime = moment().format('YYYY-MM-DD')
        if (dateString !== currentTime) {
            setFilters({
                ...filters,
                statistic_date: dateString,
                sort: 'total'
            })
            return
        }
        if (dateString === currentTime) {
            setFilters({
                ...filters,
                statistic_date: dateString,
                sort: 'time_slot',
            })
            return
        }
    }

    const handleChangeSort = (value) => {
        setFilters({
            ...filters,
            sort: value,
        })
    }

    const newFilter = _convertObject(filters)
    const currentTime = moment().format('YYYY-MM-DD')

    return (
        <div className='LabelPage ImprovedQuantityStatisticsPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div className='listFilters d-flex'>
                            <div className="sewedDate d-flex mr-3 justify-content-between align-items-center">
                                <label className='mb-0 mr-3 font-weight-bold'>Ngày hoàn thiện</label>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    defaultValue={moment()}
                                    value={moment(filters.statistic_date)}
                                    onChange={(date, dateString) => handleChangeDate(dateString)}
                                    allowClear={false}
                                />
                            </div>
                            <div className="sortBy d-flex mx-3 justify-content-between align-items-center">
                                <label className='mb-0 mr-3 font-weight-bold'>Sắp xếp</label>
                                <Select
                                    showSearch
                                    className=''
                                    showArrow
                                    placeholder='Sắp xếp'
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    value={filters.sort || []}
                                    onChange={(value) => handleChangeSort(value)}
                                    style={{ minWidth: '200px' }}
                                >
                                    <Option value={'total'}>Tổng từng user</Option>
                                    <Option value={'time_slot'} disabled={filters.statistic_date !== currentTime}>Khung thời gian</Option>

                                </Select>
                            </div>
                        </div>

                        <div className='d-flex justify-content-between align-items-center'>
                            {/* <Button
                                    type='primary'
                                    icon='export'
                                    className='float-right '
                                    onClick={this._onExport}
                                >
                                    Export
                                </Button> */}
                            <ReactHTMLTableToExcel
                                id="Export-table-xls-button"
                                className="Export-table-xls-button btn btn-primary mr-2"
                                table="ExportTable"
                                filename={`Improved-statistics-${moment().format('YYYY-MM-DD-HH-mm-ss')}`}
                                sheet="ImprovedStatistics"
                                buttonText="Export"
                            ></ReactHTMLTableToExcel>
                        </div>

                    </div>
                    <div>
                        {error && (
                            <div className="text-danger mb-2">{error}</div>
                        )}
                    </div>
                    <ImprovedQuantityStatisticsTable
                        newFilter={newFilter}
                        list={list}
                        loading={loading}
                        totalWithTimeSlot={totalWithTimeSlot}
                        total={total}
                    />
                </div>
            </div>
        </div>
    )
}

export default ImprovedQuantityStatisticsPage